import { HttpContextToken } from '@angular/common/http';
import { Injectable } from '@angular/core';
import * as forge from 'node-forge';
import { Observable, of } from 'rxjs';

export const ENCRYPT_PAYLOAD = new HttpContextToken<boolean>(() => false);

@Injectable({
  providedIn: 'root'
})
export class PayloadEncryptionService {
  getEncryptPayload(data: any, pbKey: string): Observable<string> {
    const encrypted = this.encryptWithForge(data, pbKey);

    return of(encrypted);
  }

  private encryptWithForge(data: any, pbKey: string): string {
    const publicKey = forge.pki.publicKeyFromPem(pbKey);

    const json = JSON.stringify(data);

    const encrypted = publicKey.encrypt(json, 'RSA-OAEP', {
      md: forge.md.sha1.create()
    });

    return forge.util.encode64(encrypted);
  }
}
